var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDocument = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Document"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M3.48396 12.6104H9.35705C10.5768 12.6104 11.2043 11.9688 11.2043 10.742V5.81363C11.2043 4.98167 11.0985 4.60799 10.5838 4.07921L7.79184 1.2308C7.29125 0.723153 6.87526 0.610352 6.13496 0.610352H3.48396C2.26421 0.610352 1.63672 1.25194 1.63672 2.47873V10.742C1.63672 11.9758 2.26421 12.6104 3.48396 12.6104ZM3.58267 11.4118C3.08913 11.4118 2.83531 11.1438 2.83531 10.6715V2.54924C2.83531 2.07685 3.08913 1.80894 3.58971 1.80894H5.86704V4.76312C5.86704 5.59508 6.27596 6.004 7.10792 6.004H9.99865V10.6715C9.99865 11.1438 9.75188 11.4118 9.25129 11.4118H3.58267ZM7.22779 4.94643C7.01628 4.94643 6.92461 4.85477 6.92461 4.64326V1.97815L9.83648 4.94643H7.22779Z",
    fill: "#E0E0E0"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDocument);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Document.dea28646ed05f4763655c731859a157a.svg";